<template>
  <div>
    <transition name="fade">
      <div class="loginregister billing" v-if="part === '1'">
        <div class="capture">
          <div class="contain content">
            <div class="text">
              <h2>Let's Get Started.</h2>
              <p>
                Fill out the form and we’ll get back to you with details and
                next steps.
              </p>
            </div>
            <div class="form">
              <div class="inputs">
                <div class="input">
                  <label>First name <span class="required">*</span></label>
                  <input
                    type="text"
                    v-model="user.first"
                    name="first_name"
                    required
                  />
                </div>
                <div class="input">
                  <label>Last name <span class="required">*</span></label>
                  <input
                    type="text"
                    v-model="user.last"
                    name="last_name"
                    required
                  />
                </div>
                <div class="input">
                  <label>Phone<span class="required">*</span></label>
                  <input
                    type="text"
                    v-model="user.phone"
                    name="phone"
                    required
                  />
                </div>
                <div class="input">
                  <label>Billing Email<span class="required">*</span></label>
                  <input
                    type="text"
                    v-model="user.email"
                    name="email"
                    required
                  />
                </div>
                <div class="input">
                  <label>Address Line 1<span class="required">*</span></label>
                  <input
                    type="text"
                    v-model="user.line1"
                    name="address1"
                    required
                  />
                </div>
                <div class="input">
                  <label>Address Line 2</label>
                  <input
                    type="text"
                    v-model="user.line2"
                    name="address2"
                    required
                  />
                </div>
                <div class="input">
                  <label>City <span class="required">*</span></label>
                  <input type="text" v-model="user.city" name="city" required />
                </div>
                <div class="input" v-if="user.country === 'us'">
                  <label>State <span class="required">*</span></label>
                  <select v-model="user.state" name="state" required>
                    <option :key="state" v-for="state in this.states">{{
                      state
                    }}</option>
                  </select>
                </div>
                <div class="input" v-else>
                  <label>State <span class="required">*</span></label>
                  <input
                    type="text"
                    v-model="user.state"
                    name="state"
                    required
                  />
                </div>
                <div class="input">
                  <label>ZIP code <span class="required">*</span></label>
                  <input type="text" v-model="user.zip" name="zip" required />
                </div>
                <div class="input">
                  <label>Country <span class="required">*</span></label>
                  <select v-model="user.country" name="country" required>
                    <option
                      :key="country.code"
                      :value="country.code"
                      v-for="country in this.countries"
                      >{{ country.name }}</option
                    >
                  </select>
                </div>
                <div class="btns">
                  <transition name="fade-quick">
                    <button @click="nextStep()" class="btn">Next</button>
                  </transition>
                </div>
                <transition name="fade">
                  <p v-if="errors" class="error">{{ errors }}</p>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="loginregister" v-if="part === '2'">
        <div class="capture">
          <div class="contain content">
            <div class="form">
              <div class="text">
                <h2>Checkout.</h2>
                <p>
                  Fill out the form and we’ll get back to you with details and
                  next steps.
                </p>
              </div>
              <VCreditCard
                @change="creditInfoChanged"
                direction="row-reverse"
              />

              <div class="btns left">
                <transition name="fade-quick">
                  <button
                    v-if="status == 'submit'"
                    @click="nextStep()"
                    :disabled="canCheckout"
                    class="btn"
                  >
                    Checkout
                  </button>
                </transition>

                <transition name="fade-quick">
                  <img
                    v-if="status == 'loading'"
                    class="loader"
                    src="@/assets/img/loader.gif"
                  />
                </transition>
              </div>

              <transition name="fade">
                <p v-if="errors" class="error left">{{ errors }}</p>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div class="loginregister" v-if="part === 3">
        <div class="capture">
          <div class="contain content">
            <div class="form">
              <div class="text">
                <h2>Order Success!</h2>
                <p>
                  You've successfully changed plans!
                </p>
                <img class="check" src="@/assets/img/check.svg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
const csp = require("../../node_modules/country-state-picker/index");

import VCreditCard from "v-credit-card";
import "v-credit-card/dist/VCreditCard.css";
import Swal from "sweetalert2";
const fb = require("../firebaseConfig.js");
const auth = fb.default.auth;
const functions = fb.default.functions;

export default {
  name: "Billing",
  components: {
    VCreditCard,
  },
  data() {
    return {
      countries: [],
      states: [],
      user: {
        first: "",
        last: "",
        email: "",
        line1: "",
        line2: "",
        phone: "",
        country: "us",
        zip: "",
        state: "",
        city: "",
      },
      payment: {
        name: "",
        cardNumber: "",
        expiration: "",
        security: "",
      },
      errors: null,
      status: "submit",
      part: "1",
      canCheckout: false,
    };
  },
  computed: {
    plan_id() {
      return this.$store.getters.getPlanById;
    },
    formattedData() {
      let exp = this.payment.expiration.split("/");

      return {
        number: this.payment.cardNumber,
        exp_month: parseInt(exp[0]),
        exp_year: 2000 + parseInt(exp[1]),
        cvc: this.payment.security,
        //
        name: this.user.first + " " + this.user.last,
        phone: this.user.phone,
        email: this.user.email,
        //
        address: {
          line1: this.user.line1,
          line2: this.user.line2,
          country: this.user.country,
          city: this.user.city,
          postal_code: this.user.zip,
          state: this.user.state,
        },
      };
    },
  },
  async created() {
    await (this.countries = csp.getCountries());
    await (this.states = csp.getStates("us"));
  },
  methods: {
    creditInfoChanged(values) {
      //   console.log("Credit card fields", values);
      let count = 0;
      for (const key in values) {
        this.payment[key] = values[key];
        if (values[key]) {
          count++;
        }
      }
      if (count == 4) {
        console.log(this.payment);
      }
    },
    nextStep() {
      if (this.part == "1") {
        this.validatePart1();
      } else if (this.part == "2") {
        this.status = null;
        setTimeout(() => {
          this.status = "loading";
          this.validatePart2();
        }, 300);
      }
    },

    validatePart1() {
      let user = this.user;
      let valid = true;
      for (let key in user) {
        if (key != "line2" && !user[key]) {
          if (user["country"] == "United States of America" && !user["state"]) {
            this.errors = "Please make sure that the you have selected a state";
            valid = false;
          } else {
            this.errors = "Please make sure all the fields are filled";
            valid = false;
          }
        }
      }

      if (valid) {
        this.part = "2";
        this.errors = null;
      }
    },
    async validatePart2() {
      let valid = true;
      let payment = this.payment;
      for (let key in payment) {
        if (!payment[key]) {
          valid = false;
        }
      }

      if (valid) {
        const setPayment = functions.httpsCallable("stripe-setPayment");
        const createSubscription = functions.httpsCallable(
          "stripe-purchaseSubscription"
        );

        const paymentMethod = await setPayment(this.formattedData);
        try {
          const subscription = await createSubscription({
            price_id: this.plan_id.id,
          });
          this.part = 3;
        } catch (err) {
          this.status = "submit";
          this.errors = err.message;
        }
      } else {
        this.status = "submit";
        this.errors = "Please make sure all the fields are filled";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.loginregister .contain {
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
}
.form {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 30px;
  .text {
    width: 100%;
  }
}
select {
  max-height: calc(1.2em + 24px);
  height: calc(1.2em + 24px);
  text-indent: 5px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.btns {
  margin-top: 20px;
  justify-content: flex-end;
}

.errors {
  ul {
    padding: unset;
    li {
      list-style: none;
      text-transform: capitalize;
      color: red;
    }
  }
}

.credit-card-form {
  padding-left: 0 !important;
}

.content {
  flex-wrap: wrap;
  flex-direction: column;
  max-width: 1200px;
  padding-top: 75px;
  .text {
    width: 100%;
  }
  .form {
    width: 100%;
  }
}

.loader {
  height: 50px;
  display: block;
  width: auto !important;
}

.check {
  width: 77px;
  margin-top: 38px;
}
</style>
